module.exports = __webpack_public_path__ + "static/media/fondo-opi-mobile.537d1239.jpg";